import { Popover } from 'bootstrap';
import "styles/Constat.css";﻿

    var constatContainerHTML = '<div id="Constat_container">' +
                                    '<ul class="nav nav-tabs"  role="tablist"></ul>' +
                                    '<div class="tab-content"></div>' +
                                '</div>';

    //TODO: Nombre d'items entre parenthèse pour chaque NAV_TABS
    //TODO: Activer/Désactiver les NAV_TABS en fonction de la présence d'items ou non
    export default class Constat {
      constructor() {
        $("#Constat_panel_btn").html('<i class="cv-icon bi bi-chat-left-fill"></i>');
        this._$container = $(constatContainerHTML);
        this._createNavTabs();
        $("#Constat_panel").html(this._$container);
        this._map = window.cartovista.externalInterface.map;
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onThemeSetChanged, this);
        window.cartovista.addEventListener("MasterBtnThemeSetList_onMasterThemeSetChange", this._onMasterThemeSetChanged, this);
        window.cartovista.addEventListener("BbGraphs_onCarouselSlide", this._onCarouselSlide, this);
        window.cartovista.addEventListener("BbGraphs_onTabShow", this._onTabShow, this);
        window.cartovista.addEventListener("BbGraphs_onCarouselSlideRemoved", this._onCarouselSlideRemoved, this);
        window.cartovista.addEventListener("BbGraphs_onTabShowRemoved", this._onTabShowRemoved, this);
        if (C.PANELS.CONSTAT.ACTIVATE_PANEL) {
            window.cartovista.getUIController(this._map).findInstance("Constat_panel").activate();
        }
        //initialise le constat si une thématique est déjà appliquée à l'ouverture de la carte
        if (this._map.activeThemeSet) {
            this._onThemeSetChanged({"source": this._map});
        }
      }

    _createNavTabs() {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, function(navTabConfig, idx) {
            this._$container.find(".nav-tabs").append('<li class="nav-item" role="presentation"><a class="nav-link ' + (idx == 0 ? "active" : "") + '" href="#Constat_' + navTabConfig.ID + '_tabPane" aria-controls="Constat_' + navTabConfig.ID + '_tabPane" role="tab" data-bs-toggle="tab">' + navTabConfig.TAB_TITLE + '</a></li>');
            this._$container.find(".tab-content").append(
                '<div role="tabpanel" class="tab-pane ' + (idx == 0 ? "active" : "") + '" id="Constat_' + navTabConfig.ID + '_tabPane">' +
                    navTabConfig.PANE_TITLE +
                    '<div id="Constat_' + navTabConfig.ID + '_masterThemeSet_content" class="Constat_themeSet_content"></div>' +
                    '<div id="Constat_' + navTabConfig.ID + '_themeSet_content" class="Constat_themeSet_content"></div>' +
                    '<div id="Constat_' + navTabConfig.ID + '_slideItem_content" class="Constat_slideItem_content"></div>' +
                    '<div id="Constat_' + navTabConfig.ID + '_tabItem_content" class="Constat_tabItem_content"></div>' +
                '</div>'
            );
            if (navTabConfig.POPOVER_ELEMENT_ID) {
                this._createPopover(navTabConfig);
            }
        }.bind(this));
    }

    _onThemeSetChanged(evt) {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, this._generateThemeSetContent.bind(this, evt.source.activeThemeSet ? evt.source.activeThemeSet.id : null));
    }

    _onMasterThemeSetChanged(evt) {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, this._generateMasterThemeSetContent.bind(this, evt.source.masterThemeSetId));
    }

    _onCarouselSlide(evt) {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, this._generateSlideItemContent.bind(this, evt.source.slideItemId));
    }

    _onCarouselSlideRemoved(evt) {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, this._removeSlideItemContent.bind(this, evt.source.slideItemId));
    }

    _onTabShow(evt) {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, this._generateTabItemContent.bind(this, evt.source.tabItemId));
    }

    _onTabShowRemoved(evt) {
        _.forEach(C.PANELS.CONSTAT.NAV_TABS, this._removeTabItemContent.bind(this, evt.source.tabItemId));
    }

    _generateThemeSetContent(themeSetId, navTabConfig) {
        var itemsHTML = _.reduce(navTabConfig.ITEMS, function(itemsHTML, itemObj) {
            if (typeof itemObj.THEMESETS_IDS != "undefined" && this._findMatch(itemObj.THEMESETS_IDS, themeSetId)) {
                itemsHTML.push(itemObj.HTML);
            };
            return itemsHTML;
        }.bind(this), []);
        this._$container.find("#Constat_" + navTabConfig.ID + "_themeSet_content").html(itemsHTML);
        if (navTabConfig.POPOVER_ELEMENT_ID) {
            this._createPopover(navTabConfig);
        }
    }

    _generateMasterThemeSetContent(themeSetId, navTabConfig) {
        var itemsHTML = _.reduce(navTabConfig.ITEMS, function(itemsHTML, itemObj) {
            if (typeof itemObj.MASTER_THEMESETS_IDS != "undefined" && this._findMatch(itemObj.MASTER_THEMESETS_IDS, themeSetId)) {
                itemsHTML.push(itemObj.HTML);
            };
            return itemsHTML;
        }.bind(this), []);
        this._$container.find("#Constat_" + navTabConfig.ID + "_masterThemeSet_content").html(itemsHTML);
        if (navTabConfig.POPOVER_ELEMENT_ID) {
            this._createPopover(navTabConfig);
        }
    }

    _generateSlideItemContent(slideItemId, navTabConfig) {
        var itemsHTML = _.reduce(navTabConfig.ITEMS, function(itemsHTML, itemObj) {
            if (typeof itemObj.SLIDE_ITEMS_IDS != "undefined" && this._findMatch(itemObj.SLIDE_ITEMS_IDS, slideItemId)) {
                itemsHTML.push('<span class="Constat_slideItem_element" data-slide-id="' + slideItemId + '">' + itemObj.HTML + '</span>');
            };
            return itemsHTML;
        }.bind(this), []);
        this._$container.find("#Constat_" + navTabConfig.ID + "_slideItem_content").html(itemsHTML);
        if (navTabConfig.POPOVER_ELEMENT_ID) {
            this._createPopover(navTabConfig);
        }
    }

    _removeSlideItemContent(slideItemId, navTabConfig) {
        this._$container.find(".Constat_slideItem_element[data-slide-id=\"" + slideItemId + "\"]").remove();
    }

    _generateTabItemContent(tabItemId, navTabConfig) {
        var itemsHTML = _.reduce(navTabConfig.ITEMS, function(itemsHTML, itemObj) {
            if (typeof itemObj.TAB_ITEMS_IDS != "undefined" && this._findMatch(itemObj.TAB_ITEMS_IDS, tabItemId)) {
                itemsHTML.push('<span class="Constat_tabItem_element" data-tab-id="' + tabItemId + '">' + itemObj.HTML + '</span>');
            };
            return itemsHTML;
        }.bind(this), []);
        this._$container.find("#Constat_" + navTabConfig.ID + "_tabItem_content").html(itemsHTML);
        if (navTabConfig.POPOVER_ELEMENT_ID) {
          this._createPopover(navTabConfig);
        }
    };

    _createPopover(navTabConfig){
        _.forEach(this._$container.find("#" + navTabConfig.POPOVER_ELEMENT_ID), function(popover){
            var pop = new Popover(popover, {"content": navTabConfig.POPOVER_CONTENT, html: true});
            if(pop._config.trigger == "manual"){
                this._$container.find("#" + navTabConfig.POPOVER_ELEMENT_ID).on("focus", function () {
                    pop.show();
                }).on("focusout", function () {
                    if (!$(".popover:hover").length) {
                        pop.hide();
                    }
                    else {
                        $('.popover').mouseleave(function() {
                            pop.hide();
                            $(this).off('mouseleave');
                        });
                    }
                });
            }
          }.bind(this));
    }

    _removeTabItemContent(tabItemId, navTabConfig) {
        this._$container.find(".Constat_tabItem_element[data-tab-id=\"" + tabItemId + "\"]").remove();
    }

    _findMatch(rules, value) {
        return _.some(rules, function(rule) {
            return new RegExp("^" + rule.split("*").join(".*") + "$").test(value);
        });
    }
}
